import React from "react";
import { BulletList, HeadingText, HeadingTextLight, LableValueCon, Paragraph } from "./PrivacyPolicyComponent";
import { items } from "../../PageComponentData/Profile/PrivacyPolicyPage";

export default function PrivacyPolicySection({ }) {
    return (
        <section className="pt-[12%] lg:pt-[0%] md:pt-[5%]">
            <HeadingText text={"Data Collection"} />
            <HeadingTextLight text={"We collect the following personal and professional information:"} />
            <Paragraph
                text={`Institution details, contact information, and payment details.`}
            />
            <HeadingText text={"Use of Data"} />
            <HeadingTextLight text={"The data collected is used to:"} />
            <BulletList
                items={items}
            />
            <HeadingText text={"Data Sharing"} />
            <Paragraph
                text={` User data may be shared with trusted third-party services for analytics, marketing,and platform improvement.`}
            />
            <Paragraph text={'Data will not be sold to unauthorized third parties.'} />
            <HeadingText text={"Data Storage and Security"} />
            <Paragraph
                text={` All sensitive data, including user credentials and payment information, is stored securely on AWS servers.`}
            />
            <Paragraph text={' MODO implements industry-standard security measures to protect against unauthorized access, data breaches, and other vulnerabilities.'} />
            <HeadingText text={"User Rights"} />
            <Paragraph
                text={`Users can access, update, or request deletion of their personal data by contacting MODO support. Requests are subject to legal or regulatory obligations MODO must fulfill.`}
            />
            <HeadingText text={"Cookies and Tracking"} />
            <Paragraph
                text={`MODO uses cookies and tracking technologies to enhance user experience, monitor platform performance, and gather analytics for marketing purposes.`}
            />
            <HeadingText text={"Dispute Resolution"} />
            <Paragraph
                text={`For any disputes related to data handling, users can contact MODO support.`}
            />
            <HeadingText text={"Contact Us"} />
            <HeadingTextLight
                text={`For questions regarding this Privacy Policy, reach out to:`}
            />
            <LableValueCon
                lable={'Email'}
                value={'modobackend@gmail.com'}
            />


        </section>
    )
}